import Swiper from 'swiper';
import { mediaQueryBreakpointMD, mediaQueryBreakpointSM } from '../Utils/Utils';

const ACFBlockAmbassadors = (blockElem) => {

	new Swiper(blockElem.querySelector('.swiper'), {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 1.5,
		spaceBetween: 20,
		centeredSlides: false,

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 3.5,
				loop: false,
				centeredSlides: false,
			},
			[mediaQueryBreakpointMD]: {
				slidesPerView: 6,
				loop: false,
				centeredSlides: false,
			},
		}
	});
};

export default ACFBlockAmbassadors;